<template>
  <div class="l-header-panel">
    <div v-on:click="openPanel()" v-bind:class="{isOpen:isOpenPanel}" class="button">
      <div class="button__inner">
        <div class="button__value">
          {{ calcTotal }}<small>人</small>
        </div>
      </div>
    </div>
    <transition>
      <div v-show="isOpenPanel" class="panel">
        <div class="panel__inner">
          <p class="panel__title">来客数</p>
          <ul class="items">
            <li class="item support">
              <div class="item__name"><p>対応できた</p></div>
              <div class="item__value">{{ supportNum }}<small>人</small></div>
            </li>
            <li class="item unsupport">
              <div class="item__name"><p>対応できなかった</p></div>
              <div class="item__value">{{ unsupportNum }}<small>人</small></div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/header_panel.scss';

  .button__inner {
    padding-left: 10px;
  }

  .button {
    background-image: url($static-path + 'img/factory/btn_visitor.png');
  }

  .item__name {
    width: 65%;
  }

  .item__value {
    width: 35%;
  }

  .item.unsupport {

    .item__name {
      p {
        transform-origin: 0 0;
        transform: scaleX(0.65);
        width: 120%;
        white-space: nowrap;
      }
    }

    .item__value {
      color: #000;
    }
  }
</style>

<script>
  export default {
    name: 'Visitor',
    props: ['passedTestState'],
    
    data() {
      return {
        isOpenPanel: false,
        supportNum: 10,
        unsupportNum: 25
      }
    },

    computed: {

      calcTotal(){

        let total = this.supportNum + this.unsupportNum;

        return total;
      }
    },

    methods: {

      openPanel() {

        if (this.isOpenPanel) {
          this.isOpenPanel = false;
        } else {
          this.isOpenPanel = true;
        }
      },

      addComma(num){

        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
    },

    watch: {

      // 合格テストリストの値を反映
      passedTestState(val) {

        const default_support_num = 10;
        const default_unsupport_num = 25;

        // 来客数を適当に増やす
        const passed_items = this.$store.getters['PassedTest/items'];
        const passed_num = passed_items.length;

        let add_support_num = 0;
        let add_unsupport_num = 0;

        for (let i=0; i < passed_num; i++) {

          const item = passed_items[i];

          if (item.testType == 'study') {

            if (item.testId > 1) {
              add_support_num += 10;
              add_unsupport_num += 2;
            } else {
              add_support_num += 8;
              add_unsupport_num += 1;
            }

          } else if (item.testType == 'exam') {

            if (item.testId > 1) {
              add_support_num += 15;
              add_unsupport_num += 3;
            } else {
              add_support_num += 12;
              add_unsupport_num += 2;
            }
          }
        }

        this.supportNum = default_support_num + add_support_num;
        this.unsupportNum = default_unsupport_num + add_unsupport_num;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Factory/Visitor.vue